var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FactSheet',{attrs:{"entity-external-id":_vm.entityExternalId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }